import { create } from "zustand";

const playerTrucLocStore = create((set, get) => ({
  /**
   * {
            isRuning: isRuning,
            count: count,
            matchNum: matchNum,
            winNum: winNum
        }
   */
  playerTrucLocs: {}, // Lưu trữ tất cả các player và equipments của họ

  // Cập nhật một equipments trong một player cụ thể
  updateSingleTrucLoc: (playerId, key, value) => {
    if (get().playerTrucLocs[playerId] == null) return;
    if (value === get().playerTrucLocs[playerId][key]) {
      return;
    }
    set((state) => (
      {
        playerTrucLocs: {
          ...state.playerTrucLocs,
          [playerId]: {
            ...state.playerTrucLocs[playerId], // Giữ lại các equipments cũ
            [key]: value, // Cập nhật equipments cụ thể
          },
        },
      }))
  },

  // Cập nhật toàn bộ Equipment của một player
  updatePlayerTrucLoc: (playerId, newTrucLoc) =>
    set((state) => ({
      playerTrucLocs: {
        ...state.playerTrucLocs,
        [playerId]: newTrucLoc, // Cập nhật toàn bộ equipments của player
      },
    })),

  // Cập nhật nhiều player cùng lúc
  updateMultiplePlayers: (newTrucLoc) =>
    set((state) => ({
      playerTrucLocs: {
        ...state.playerTrucLocs,
        ...newTrucLoc, // Merge với equipments hiện tại
      },
    })),
}));

export default playerTrucLocStore;
